import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Headset } from "lucide-react";

/**
 * Auth sayfalarının altındaki destek çıkışı.
 *
 * Giriş yapamayan kullanıcı desteğe en çok ihtiyaç duyan kişidir
 * (doğrulama e-postası gelmedi, şifre sıfırlanamıyor vb.) ve bu ekranlarda
 * ne sidebar ne de header bulunur.
 */
export function AuthSupportLink() {
  const { t } = useTranslation();

  return (
    <p className="text-center text-sm text-muted-foreground">
      {t("support.authPrompt")}{" "}
      <Link
        to="/support"
        className="inline-flex items-center gap-1 font-semibold text-text-secondary dark:text-gray-100 underline-offset-2 transition-colors hover:underline"
      >
        <Headset className="h-3.5 w-3.5" />
        {t("support.authLink")}
      </Link>
    </p>
  );
}
